import Vue from 'vue';

Vue.directive('permission', {
  inserted: function (el, binding, vnode) {
    // Obtén los permisos del usuario desde el store
    let userPermissions = vnode.context.$store.state.permissions || [];

    // Ensure userPermissions is an array
    if (!Array.isArray(userPermissions)) {
      console.warn('userPermissions is not an array, defaulting to empty array');
      userPermissions = [];
    }

    // Convierte el array de permisos a minúsculas para comparación case-insensitive
    const permissionsLowerCase = userPermissions.map(p => String(p).toLowerCase());

    if (!permissionsLowerCase.includes(binding.value.toLowerCase())) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  }
});